//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Componentes material
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';

/**
 * Estilos CSS do componente
 */
const style = () => ({
    texto: {
        whiteSpace: 'pre-line'
    }
});

/**
 * Componente para renderizar o conteúdo de uma questão com texto fixo
 * @param {Object} props Propriedades do componente
 * @param {AvaliacaoResposta} props.questao Dados da questão
 * @param {Object} props.classes Classes CSS do componente
 */
function AvaliacaoRespostaTextoFixo({ questao, classes }) {
    if (!questao.exibeResultado) {
        return (
            <Grid item xs={12} >
                <FormLabel component="legend" >{questao.titulo}</FormLabel>
                <Typography className={classes.texto} align="justify" >{questao.conteudoTexto}</Typography>
            </Grid>
        );
    } else {
        return null;
    }
}

AvaliacaoRespostaTextoFixo.propTypes = {
    /** Objeto contendo os dados da questão */
    questao: PropTypes.instanceOf(AvaliacaoResposta).isRequired,
    //Classes CSS do componente
    classes: PropTypes.shape({
        texto: PropTypes.string
    })
};

export default withStyles(style)(AvaliacaoRespostaTextoFixo);